export default __webpack_public_path__ + "static/media/buttons1.e7fcf8be.jpg";